import ChartPanel from './chart-panel.vue'
export default ChartPanel
